import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "webform/store/store";

export const attachmentsSelector = (state: RootState) => state.attachments;
export const attachmentsListSelector = createSelector(attachmentsSelector, ({attachments}) => attachments);
export const uploadedAttachmentIdsSelector = createSelector(attachmentsSelector, ({attachments}) =>
    attachments.filter(({id, error, isUploaded}) => id && isUploaded && !error).map(({id}) => id as number),
);
export const isAnyAttachmentUploadingSelector = createSelector(attachmentsSelector, ({attachments}) =>
    attachments.some(({isUploaded, error}) => !isUploaded && !error),
);
export const hasAnyAttachmentErrorSelector = createSelector(attachmentsSelector, ({attachments}) =>
    attachments.some(({error}) => !!error),
);
